import React from "react";
import { GridContainer, GridRow, GridColumn } from "arv-reactcomponents";

import { CONTACT_US_V2 } from "npmlinks-constants";
import StaticPageTitle from "../../../../component/StaticPageTitle";
import ContactUsForm from "../ContactUsForm";
import ContactUsMessage from "../ContactUsMessage";

const DesktopContactUs = () => (
  <GridContainer>
    <GridRow>
      <GridColumn>
        <StaticPageTitle.component
          title={CONTACT_US_V2.title}
          className="nw-terms-color"
        />
      </GridColumn>
    </GridRow>
    <GridRow className="nwc-main-content-wrapper nw-desktopcontactus-messagecontainer">
      <GridColumn className="nwc-grid-col-sm">
        <ContactUsMessage.component />
      </GridColumn>
    </GridRow>
    <GridRow className="nwc-main-content-wrapper">
      <GridColumn>
        <h1 className="nw-contatusform-title"> {CONTACT_US_V2.formTitle} </h1>
      </GridColumn>
    </GridRow>
    <GridRow className="nwc-main-content-wrapper nw-desktopcontactus-formcontainer">
      <GridColumn className="nwc-grid-col-sm">
        <ContactUsForm.component />
      </GridColumn>
    </GridRow>
  </GridContainer>
);

const getFinalComponent = component => component;

const ProjectComponent = {
  getFinalComponent,
  wrapper: DesktopContactUs,
  component: DesktopContactUs,
};

export default ProjectComponent;



// WEBPACK FOOTER //
// ./src/pages/ContactUs/V2/DesktopContactUs/index.js